export const baseURL =
  // eslint-disable-next-line no-undef
  process.env.REACT_APP_BASE_SERVICES_URL || "http://localhost:3202";
